<template>
  <div>项目日志</div>
</template>

<script>
export default {
  name: 'journal'
}
</script>

<style lang="less" scoped></style>
